import { ExternalNumberDetail } from 'src/app/pages/extension-details/models/extension-detail-view.model';
import { ExtensionOption } from 'src/app/pages/extension-register/models/extension-option.interface';

export enum ExtensionChipInputType {
   PhoneNumber,
   Extension,
}

export interface ExtensionChipInputOption {
   stepId: number;
   type: ExtensionChipInputType;
   value: ExtensionOption | ExternalNumberDetail | string;
   isDeleted?: boolean;
}
